const makeAmazonLinkFunctional = () => {
  const productOptions = document.querySelector('#product-options');
  const optionRadios = document.querySelectorAll('.swatch-element input[type="radio"]');
  const amazonLinkElementText = document.querySelector('.link--amazon').textContent;
  
  const optionClassNames = {
    selectedSwatch: 'selected-swatch',
    swatchElement: 'swatch-element',
    optionRow: 'product-option-row'
  };
  
  const removeOptionsSelectionStyle = (radio) => {
    const optionRow = radio.closest(`.${optionClassNames.optionRow}`);
    const options = optionRow.querySelectorAll(`.${optionClassNames.swatchElement}`);
  
    options.forEach(option => option.classList.remove(optionClassNames.selectedSwatch)); 
  };
  
  const markCurOptionAsSelected = (radio) => {
    const swatchElement = radio.closest(`.${optionClassNames.swatchElement}`);
  
    swatchElement.classList.add(optionClassNames.selectedSwatch)
  };
  
  const getSelectedOptionValues = (selectedOptions) => {
    return [...selectedOptions].reduce((acc, curRadio) => {
       acc.push(curRadio.value);
  
       return acc;
     }, []);
  };
  
  const getVariantFromOptions = (selectedOptions) => {
    return product.variants.find(variant => {
       let pass = true;
  
       for (let i = 0; i < selectedOptions.length; i++) {
         if (selectedOptions.indexOf(variant.options[i]) === -1) {
           pass = false;
           break;
         }
       }
  
       return pass;
     })
  };
  
  const toggleElement = (element, action) => {
    element.style.opacity = action === 'show' ? '1' : '0';
    element.style.visibility = action === 'show' ? 'visible' : 'hidden';
  };
  
  const makeLinkDisabledIfVariantSoldOut = (variantID) => {
    const variantMatch = product.variants.find(variant => variant.id === variantID);
    const amazonLinkWrapperElement = document.querySelector('.button-wrapper');
    const amazonLinkElement = document.querySelector('.link--amazon');
    
    if (variantMatch.available) {
      amazonLinkWrapperElement.classList.remove('link-disabled');
      amazonLinkElement.textContent = amazonLinkElementText;
      
      return;
    };
  
    amazonLinkElement.textContent = "Out of stock";
    
    amazonLinkWrapperElement.classList.add('link-disabled');
  };
  
  const changeAmazonLink = (matchedVariantID) => {
    variants.forEach(variant => {
      if (variant.id !== matchedVariantID) return;
      
      const amazonLinkWrapperElement = document.querySelector('.button-wrapper');
      const amazonLinkElement = document.querySelector('.link--amazon');
      const amazonLinkHref = variant.amazonLink;
      const isAmazonLinkValid = amazonLinkHref && amazonLinkHref !== '#';
  
      if(!isAmazonLinkValid) {
        toggleElement(amazonLinkWrapperElement, 'hide');
          
        return;
      }
  
       makeLinkDisabledIfVariantSoldOut(variant.id);
       toggleElement(amazonLinkWrapperElement, 'show');
        
       amazonLinkElement.href = amazonLinkHref; 
    });
  };

  const changeImageBasedOnVariant = variant => {
    var selected_thumb = $(
        '.image-gallery__thumbnail-wrapper[data-image-id="' + variant.images.id + '"]'
      );
  
    if (
      selected_thumb.length &&
      !selected_thumb.hasClass('image-gallery__thumbnail-wrapper--active')
    ) {
      selected_thumb.trigger('click');
    }
  };
  
  const changeMainImageOnVariantSelect = (matchedVariant) => {  
    const matchedVariantFromCustomVariantsObj = variants.find(
      variant => variant.id === matchedVariant.id
    );
    changeImageBasedOnVariant(matchedVariantFromCustomVariantsObj);
  };

  const setUpInitialVariantImage = (radio, i) => {
    const checkedRadios = document.querySelectorAll('.swatch-element input[type="radio"]:checked');
    const label = radio.closest('.swatch-element').querySelector('label');
    const selectedOptions = getSelectedOptionValues(checkedRadios);
    const matchedVariant = getVariantFromOptions(selectedOptions);
    const matchedVariantID = matchedVariant.id;

    changeMainImageOnVariantSelect(matchedVariant, i);
    removeOptionsSelectionStyle(radio);
    markCurOptionAsSelected(radio);   
    changeAmazonLink(matchedVariantID);
};

  optionRadios.forEach((radio, i) => {    
   radio.addEventListener('click', () => {
     const checkedRadios = document.querySelectorAll('.swatch-element input[type="radio"]:checked');
     const label = radio.closest('.swatch-element').querySelector('label');
     const selectedOptions = getSelectedOptionValues(checkedRadios);
     const matchedVariant = getVariantFromOptions(selectedOptions);
     const matchedVariantID = matchedVariant.id;

     changeMainImageOnVariantSelect(matchedVariant);
     removeOptionsSelectionStyle(radio);
     markCurOptionAsSelected(radio);   
     changeAmazonLink(matchedVariantID);
    });
  });

  optionRadios.forEach((radio, i) => {
    if (i === 0) {
      radio.checked = true;
      setTimeout(() => {
        radio.click();
      }, 800)
    }
  });

};

makeAmazonLinkFunctional();

